/**
 * /tenants/$slug/directory/authority — route shim.
 *
 * Validates the object-kind search param, prefetches the claim list, and mounts
 * the page. Reading authority is never gated on the Directory product area, so
 * this loader is safe for any tenant with directory.read; the 402 that a write
 * can return is handled where the write happens.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AuthorityPage } from "@/features/directory-authority/pages/authority-page";
import {
  authoritySearchSchema,
  type AuthoritySearch,
} from "@/features/directory-authority/schemas";

export const Route = createFileRoute("/_authed/tenants/$slug/directory/authority")({
  validateSearch: (raw: Record<string, unknown>): AuthoritySearch =>
    authoritySearchSchema.parse(raw),
  component: AuthorityPage,
});
